/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_itineraire': {
    width: 43,
    height: 43,
    viewBox: '0 0 43 43',
    data: '<path pid="0" d="M12.765 10.75H27.01a6.719 6.719 0 100-2.687H12.765a7.39 7.39 0 000 14.78h14.782a4.703 4.703 0 110 9.407H15.99a6.719 6.719 0 100 2.688h11.556a7.39 7.39 0 100-14.782H12.765a4.703 4.703 0 110-9.406zm20.829-5.375a4.031 4.031 0 110 8.062 4.031 4.031 0 010-8.062zM9.406 37.625a4.03 4.03 0 110-8.062 4.03 4.03 0 010 8.062z" _fill="#5F01D3"/>'
  }
})
